module.exports = __webpack_public_path__ + "img/roadmap-impostor-2.37709d14.svg";